import { FC, useContext, PropsWithChildren } from "react";

import { Navigate } from "react-router-dom";
import { AuthContext } from "@components/AuthProvider/contexts/Auth.context";

export const PublicRoute: FC<PropsWithChildren> = ({ children }) => {
  const context = useContext(AuthContext);

  if (context?.user || context?.authUser) return <Navigate to="/portal" />;

  return <>{children}</>;
};
